module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA4CAYAAACc//oCAAAAAXNSR0IArs4c6QAAAKFJREFUWEft2DEOgkAUhOF5yOUMnRWNnXgKCxISLuEhiJfwJJ7CJY69AZcQDc2/9ezL5GtediM1utjq9KdThA7lVcPc+KAAAggggAACY6Pa1vHrLgqFrf2afZVdRkuGulWZHkpLsp8ZCiCAAAIIIIAAAggggAACWYHxrCr74LB2L+uWzU0EolAf0n32m+55ktcM/tWdoAACCCCAAAIIbC3wBuJ2GMUj/JWIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1.png
// module id = Txl5
// module chunks = 0